import { ReactNode } from "react";
import "./FullModalContainer.css";

interface FullModalContainerProps {
  title: string;
  children: ReactNode;
}

export const FullModalContainer: React.FC<FullModalContainerProps> = ({
  title,
  children,
}) => {
  return (
    <div className="fullModalContainer">
      <div className="fmcTitle">{title}</div>
      <div className="fmcContent">{children}</div>
    </div>
  );
};
